export const lookupMetadataLabel = (options, code, fallback = "—") => {
  if (!code) return fallback;
  const match = (options || []).find((option) => option.code === code);
  return match?.label || code;
};

export const formatAccountPlanFrequency = (frequency, metadata, t) =>
  lookupMetadataLabel(metadata?.frequencies, frequency, t(`ccAccountPlanFrequency_${frequency}`, frequency));

export const formatAccountPlanAssignmentMode = (mode, metadata, t) =>
  lookupMetadataLabel(metadata?.assignmentModes, mode, mode);

export const formatAccountPlanReminder = (daysBefore, metadata) => {
  const match = (metadata?.reminderOptions || []).find(
    (option) => Number(option.daysBefore) === Number(daysBefore)
  );
  return match?.label || `${daysBefore} days before`;
};

export const formatAccountPlanPriority = (priority, metadata) =>
  lookupMetadataLabel(metadata?.priorities, priority, priority);

export const formatAccountPlanScheduleSummary = (planType, metadata, t) => {
  if (!planType) return t("ccEmDash");
  const frequency = formatAccountPlanFrequency(planType.frequency, metadata, t);
  const count = Number(planType.installmentCount || 0);
  return t("ccAccountPlanTypeScheduleSummary")
    .replace("{frequency}", frequency)
    .replace("{count}", String(count));
};

export const priorityStatusCode = (priority) => {
  switch (String(priority || "").toUpperCase()) {
    case "HIGH":
      return "ESCALATED_L1";
    case "LOW":
      return "SCHEDULED";
    default:
      return "PENDING";
  }
};
